import React from 'react';
import { TextInput } from 'src/tef/components/forms/TextInput';
import { ComponentVariant } from 'src/tef/components/utils/types';

interface TextInputWithClearButtonProps extends Omit<React.ComponentProps<typeof TextInput>, 'showClearButton'> {
  value: string;
  onClear: () => void;
  variant?: ComponentVariant;
}

export const TextInputWithClearButton = React.forwardRef<HTMLInputElement, TextInputWithClearButtonProps>(
  ({ value, onClear, variant, ...props }, ref) => {
    return (
      <TextInput
        ref={ref}
        value={value}
        showClearButton={true}
        onClear={onClear}
        variant={variant || { style: 'withClearButton', size: 'md' }}
        {...props}
      />
    );
  }
);

TextInputWithClearButton.displayName = 'TextInputWithClearButton';
